let cssClassIdx = 0;

export function getClassId() {
    return cssClassIdx++;
}
